if($('.type-detail').length){
    var textFriends = 'Alternatíva'
    if($('table.detail-parameters tbody tr th').text().trim().includes(textFriends)){
                $('table.detail-parameters tbody tr:contains('+textFriends+')').closest('tr').hide()
                var apiUrl = "https://friends.shopcode.cz/new/api-products.php";
                var section = "batteryImportSk";
                var codes = [];
                $('table.detail-parameters tbody tr').each(function () {
                    var headerText = $(this).find('th span.row-header-label').text().trim();
                    var friendName = $(this).find('td').text().trim();
                    if (headerText.includes(textFriends)) {
                        $(this).closest('tr').hide()
                        codes.push(friendName);
                    }
    });
       if (codes.length === 0) {
            console.warn("Žádné hodnoty " + textFriends + " nebyly nalezeny.");
        } else {
            $.ajax({
                url: apiUrl,
                type: "GET",
                data: {
                    section: section,
                    codes: getShoptetDataLayer('product').codes[0].code
                },
                dataType: "json",
                success: function(response) {
                    console.log("API odpověď:", response);
                    if (!response || !response.result || !response.result.length) {
                        console.warn("Žádné výsledky v odpovědi.");
                        return;
                    }
                    $('.p-info-wrapper').append('<div class="alternativeProducts"></div>')
                    const alternatives = response.result[0].alternatives || [];
                    alternatives.sort((a, b) => a.NAME.localeCompare(b.NAME, 'sk', { sensitivity: 'base' }));
                    const $list = $('.alternativeProducts');
                    $list.empty();
                    alternatives.forEach(item => {
                         if (item.is_main) return;
                        const price = item.ACTIONPRICE > 0 ? item.ACTIONPRICE : item.PRICE;
                        $list.append(`
                            <div class="altItem" data-primary="${item.is_main}">
                                <a href="${item.URL}"></a>
                                <div class="image"><img src="${item.IMAGE}" alt="${item.NAME}"></div>
                                <span class="name">${item.NAME}</span>
                                <span class="price">${price} €</span>
                            </div>
                        `);
                    });
                },
                error: function(xhr, status, error) {
                    console.error("Chyba při načítání:", error);
                }
            });
        }
    }
}